import { useState } from 'react';

export default function ContactForm() {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "269ddd2f-8d78-4468-a11a-0a18d16da7fa");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    setResult(data.success ? "Üzenet elküldve! Köszönöm megkeresését!" : "Hiba! Üzenet küldése sikertelen! Próbálja meg később.");
  };
  
  return (
    <div className='contact-container'>
      <h1>Írjon nekünk!</h1>

        <form onSubmit={onSubmit}>

        <h2>Név:</h2>

        <input type="text" name="name" required/>

        <h2>Email:</h2>

        <input type="email" name="email" required/>
        <h2>Üzenet:</h2>

        <textarea name="message" required></textarea>

        <button  type="submit">Küldés</button>    

        <p className='contact-result'>{result}</p>
        
        </form>

    </div>
  )
}
